// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"164":"4aa1866e","249":"dac286a4","530":"0b12db27","734":"3cc85e99"}[chunkId] + ".chunk.css";
};